import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { first, map, tap } from 'rxjs/operators';
import { DevicesRouterStoreSelectors, RouterStoreStates } from '../router';
import { SecurityInfoStoreActions, SecurityInfoStoreStates } from '../security-info';

@Injectable()
export class SecurityInfoResolver {
  constructor(
    private readonly routerStore: Store<RouterStoreStates.RouterState>,
    private readonly SecurityInfoStore: Store<SecurityInfoStoreStates.SecurityInfoState>
  ) {}

  resolve(): Observable<boolean> {
    return this.routerStore.select(DevicesRouterStoreSelectors.selectUdid).pipe(
      tap((udid) => {
        this.SecurityInfoStore.dispatch(
          SecurityInfoStoreActions.SecurityInfoResolverActions.securityInfoRequested({
            udid,
          })
        );
      }),
      map(() => true),
      first()
    );
  }
}
